import React, { useState, useEffect, useRef } from "react";
import AddNewContactModal from "./AddNewContactModal";
import useForm from "../../pages/distributerMaster/useForm";
import { validationContact } from "../../validation/ValidateContact";

const AdditionalContact = ({
  values,
  setValues,
  HandleSubmit,
  handleRedirect,
  loading,
  designationList,
  departmentList
}) => {
  const [show, setShow] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { errors, setErrors } = useForm();
  const [contact, setContact] = useState({
    id: 0,
    name: "",
    email: "",
    phone: "",
    departmentId: "",
    designationId: "",
    department: "",
    designation: "",
  });
  const [department, setDepartment] = useState("");
  const [designation, setDesignation] = useState("");

  const handleShow = () => {
    setShow(true);
  };

  const handleChange = (e) => {
    setContact({
      ...contact,
      [e.target.name]: e.target.value,
    });
  };

  const handleContactSubmit = (e) => {
    setErrors(validationContact(contact));
    setIsSubmitting(true);
  };

  const handleClose = (e) => {
    setShow(false);
    setContact({
      name: "",
      email: "",
      department: "",
      designation: "",
      phone: "",
      departmentId: "",
      designationId: "",
    });
    setDepartment("");
    setDesignation("");
    setErrors({});
    setIsSubmitting(false);
  };

  useEffect(() => {
    if (Object.keys(errors).length == 0 && isSubmitting) {
      if (contact?.id > 0) {
        const con = [...values?.distributorContacts];
        const newCon = con?.map((itm) => {
          if (itm?.id == contact?.id) {
            itm.id = contact?.id;
            itm.name = contact?.name;
            itm.designation = contact?.designation;
            itm.phone = contact?.phone;
            itm.email = contact?.email;
            itm.designationId = contact?.designationId;
            itm.department = contact?.department;
            itm.departmentId = contact?.departmentId;
          }
          return itm;
        });
        setValues({ ...values, distributorContacts: newCon });
      } else {
        const len = values?.distributorContacts?.length * 1 + 1;
        let cont = {
          id: len,
          name: contact?.name,
          phone: contact?.phone,
          email: contact?.email,
          designation: contact?.designation,
          department: contact?.department,
          designationId: contact?.designationId,
          departmentId: contact?.departmentId,
        };
        setValues({
          ...values,
          distributorContacts: [...values?.distributorContacts, cont],
        });
      }
      handleClose();
    }
  }, [errors]);

  const handleDeleteContact = (e, ind) => {
    const contactsCopy = [...values?.distributorContacts];
    contactsCopy.splice(ind, 1);
    setValues({ ...values, distributorContacts: contactsCopy });
  };

  const handleEditContact = (e, ind) => {
    const contactsCopy = [...values?.distributorContacts];
    const editCont = contactsCopy[ind];
    setContact(editCont);
    setShow(true);
  };

  const handleDepartmentChange = (selectedOption) => {
    setContact({
      ...contact,
      department: selectedOption,
      departmentId: selectedOption?.value,
    });
  };

  const handleDesignationChange = (selectedOption) => {
    setContact({
      ...contact,
      designationId: selectedOption?.value,
      designation: selectedOption,
    });
  };

  return (
    <>
      <div className="card mt-1 contact-info-card mb-2">
        <div class="card-header">
          <h2>Contact Information</h2>
        </div>
        <div className="card-body">
          <div className="row mt-2 additional-contact-add-area">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
              <div className="text-right">
                <button
                  type="button"
                  className="btn add-new-contact-btn"
                  onClick={handleShow}
                >
                  <i class="fas fa-plus-square"></i> Add New Contact
                </button>
              </div>
            </div>
            {values?.distributorContacts?.length > 0
              ? values?.distributorContacts?.map((contact, ind) => {
                const desig = designationList?.find(
                  (itm) => itm?.id == contact?.designationId
                );
                return (
                  <>
                    <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-12 col-xs-12 mb-2">
                      <div className="added-contact">
                        <div className="contact-edit-options">
                          <i
                            className="far fa-edit"
                            title="View"
                            onClick={(e) => handleEditContact(e, ind)}
                          ></i>
                          <i
                            className="far fa-trash-alt red-tooltip"
                            title="Delete"
                            onClick={(e) => handleDeleteContact(e, ind)}
                          ></i>
                        </div>
                        <i className="far fa-user-circle"></i>
                        <h5>{contact?.name}</h5>
                        <span>{contact?.email}</span>
                        <p>{desig?.designationName}</p>
                        <p>{contact?.phone}</p>
                      </div>
                    </div>
                  </>
                )
              }
              )
              : ""}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">
          <div className="save-btns d-flex justify-content-end">
            <button className="btn cancel-btn" onClick={handleRedirect}>
              Cancel
            </button>
            <button
              className="btn save-btn"
              onClick={HandleSubmit}
              disabled={loading}
            >
              {values?.id ? "Update" : "Save"}
            </button>
          </div>
        </div>
      </div>
      <AddNewContactModal
        show={show}
        contact={contact}
        values={values}
        handleClose={handleClose}
        errors={errors}
        handleChange={handleChange}
        handleContactSubmit={handleContactSubmit}
        department={department}
        designation={designation}
        departmentData={departmentList}
        designationData={designationList}
        handleDepartmentChange={handleDepartmentChange}
        handleDesignationChange={handleDesignationChange}
        setDesignation={setDesignation}
        setDepartment={setDepartment}
        setContact={setContact}
        setErrors={setErrors}
      />
    </>
  );
};

export default AdditionalContact;
